/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@package/api-client/client-config";
import type { ListAppsQueryResponse, ListAppsPathParams } from "../../types/appsController/ListApps.ts";
import type { RequestConfig, ResponseErrorConfig } from "@package/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listApps } from "../../client/appsController/listApps.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAppsQueryKey = (orgId: ListAppsPathParams["orgId"]) => [{ url: '/api/organizations/:orgId/apps/', params: {orgId:orgId} }] as const

export type ListAppsQueryKey = ReturnType<typeof listAppsQueryKey>

export function listAppsQueryOptions(orgId: ListAppsPathParams["orgId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = listAppsQueryKey(orgId)
  return queryOptions<ListAppsQueryResponse, ResponseErrorConfig<Error>, ListAppsQueryResponse, typeof queryKey>({
   enabled: !!(orgId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return listApps(orgId, config)
   },
  })
}

/**
 * @summary List apps for organization
 * {@link /api/organizations/:orgId/apps/}
 */
export function useListApps<TData = ListAppsQueryResponse, TQueryData = ListAppsQueryResponse, TQueryKey extends QueryKey = ListAppsQueryKey>(orgId: ListAppsPathParams["orgId"], options: 
{
  query?: Partial<QueryObserverOptions<ListAppsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? listAppsQueryKey(orgId)

  const query = useQuery({
   ...listAppsQueryOptions(orgId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}